var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('org/components/splitBanner'));
}); 